module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-report"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_c('TextInput', {
    attrs: {
      "formInputResetFlag": _vm.formInputResetFlag,
      "id": 'on_date',
      "value": _vm.on_date,
      "required": true,
      "label": "Dzień",
      "type": "date"
    },
    model: {
      value: (_vm.on_date),
      callback: function($$v) {
        _vm.on_date = $$v
      },
      expression: "on_date"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "formInputResetFlag": _vm.formInputResetFlag,
      "id": 'from_hour',
      "value": _vm.from_hour,
      "required": true,
      "label": "Od",
      "type": "time"
    },
    model: {
      value: (_vm.from_hour),
      callback: function($$v) {
        _vm.from_hour = $$v
      },
      expression: "from_hour"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "formInputResetFlag": _vm.formInputResetFlag,
      "id": 'to_hour',
      "value": _vm.to_hour,
      "required": true,
      "label": "Do",
      "type": "time"
    },
    model: {
      value: (_vm.to_hour),
      callback: function($$v) {
        _vm.to_hour = $$v
      },
      expression: "to_hour"
    }
  }), _vm._v(" "), _c('SelectOption', {
    attrs: {
      "formInputResetFlag": _vm.formInputResetFlag,
      "options": _vm.placeChoices,
      "required": true,
      "label": "Miejsce",
      "id": "place"
    },
    model: {
      value: (_vm.place),
      callback: function($$v) {
        _vm.place = $$v
      },
      expression: "place"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-orange float-right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n            Dodaj raport\n        ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-933f8d4c!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/ia/AddReport.vue
// module id = 1107
// module chunks = 0